import { render, staticRenderFns } from "./Companias.vue?vue&type=template&id=07a68ec2&"
import script from "./Companias.vue?vue&type=script&lang=js&"
export * from "./Companias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports